export default __webpack_public_path__ + "static/media/Human1.2fa43c0e.png";